import React, { useState, useEffect, useContext, useRef } from "react";
import TrackContext from "../../contexts/track-context";
import TrackItem from "../TrackItem";
import API from "../../services/api";
import AddTrackToProjectPopup from "../Projects/addTrackToProjectPopup";
import Helper from "../../services/helper";
import "./style.css";
import { useHistory, useParams } from "react-router-dom";
import Amplitude from "amplitudejs";
import "./style.css";
import { BouncingLoader } from '../../pure-components/Loader';
import MewoService from "../../services/mewoService";
import Constants from "../../services/constants";
import { toast } from "react-toastify";
import { ErrorToast, WarningToast } from "../../pure-components/CustomToast";
import HarvestService from "../../services/harvestService";
import Track from "../Track";

const ArtistTrackView = (props) => {
  let ref = useRef(null);
  let trackContext = useContext(TrackContext);
  const history=useHistory()
  const [artistTracks, setArtistTracks] = useState([]);
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [trackToBeAddedToProject, setTrackToBeAddedToProject] = useState("");
  const [loaderAddTrackToProject, setLoaderAddTrackToProject] = useState(false);
  const [expandedTrackId, setExpandedTrackId] = useState("");
  const pageId='artist'
  const [isLoading, setIsLoading]=useState(false);
  const [artistData, setArtistData] = useState(null);
  const [allTracksLoaded, setAllTracksLoaded] = useState(false);
  const [excludedArr, setExcludedArr]  = useState([]);
  const [loadMore, setLoadMore] = useState(false);
  const [initialized, setInitialized] = useState(false);

  
  const [downloadingTracks, setDownloadingTracks] = useState([]);
  const [favingTracks, setFavingTracks] = useState([]);
  

  const {artistId}=useParams();
  useEffect(() => {
    // console.log("1st loading", loadMore, allTracksLoaded)
    getAllArtistTracks();
  }, [artistId]);

  const getAllArtistTracks=async()=>{
    // console.log("loading data")
    if(!isLoading && !allTracksLoaded){
      setIsLoading(true)
      const trackfilter = {
        "SearchFilters": {
          "SearchType": "Normal",
          "IncludeInactive": "false",
          "MainOnly": "true",
          "SearchTermBundle": {
            "St_Rightholder": { 
              "RightHolders": artistId, 
              "Negative": "false" 
            } 
          },
          "ResultView": { 
            "View": "Track", 
            "Sort_Predefined": "ReleaseDate_Desc", 
            "RankExpression": "", 
            "Skip": artistTracks?.length, 
            "Limit": "100", 
            include_lyrics : true
          }
        }
      }
      await loadMusicData(trackfilter);
    }
  }

  const getTracks=()=>{
    trackContext.setIsLoading(true);
    API.getAllArtistTracks(artistId).then(res => {
      if(res?.success){
        if(res?.data?.length)
        {
          setArtistTracks(res.data);
          trackContext.setTrackData(res.data);
          trackContext.setSongData(res.data)
        }
      }else{
        Helper.handleError(res);
      }
      trackContext.setIsLoading(false);
      setIsLoading(false)
    })
  }

  const loadMusicData = async(filter) => {

    const reqObj = {
      refUrl : `/cloudsearch/{memberToken}`, 
      method : 'post',
      headers : {
          "Accept" : "application/json",
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
      },
      data : JSON.stringify(filter)
    };
    await HarvestService.loadHarvestData(reqObj).then((resp) => {
      // console.log("response data : ", resp)
        
      if(!resp?.Tracks || resp?.Tracks?.length === 0){
        console.warn("No track(s) found for composer : ", artistId);
        toast(({ closeToast }) => <WarningToast  message={"No tracks found for searched query."}/>);
        return;
      }
      if(resp?.TotalTracks > (artistTracks?.length + resp.Tracks?.length)){
        setAllTracksLoaded(false);
      }else{
        setAllTracksLoaded(true);
      }
      setArtistTracks([...artistTracks, ...resp?.Tracks]);
      setIsLoading(false);
    }).catch((err) => {
      console.log("Track List Loading Error : ", err);
      //Modify the error handling when array returned as error
      toast(({ closeToast }) => <ErrorToast  message={"Searched track list loading error."}/>);
      setIsLoading(false);
      setAllTracksLoaded(true);
    });
    
  }

  useEffect(() => {
    if(artistTracks?.length > 0){
      let tempData = artistTracks[0]?.Composer;
      setArtistData(tempData)
    }
  },[artistTracks])
 

  const displayProjectModal = (trackId) => {
    setTrackToBeAddedToProject(trackId);
    setShowProjectModal(true);
  };

  const closeProjectModal = () => {
    setShowProjectModal(false);
    setLoaderAddTrackToProject(false);
  };

  useEffect(() => {
    if (ref.current !== null) {
      // INTERSECTION OBSERVER
      let options = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0,
      };
      let observer = new IntersectionObserver(loadMoreTracks, options);
      let target = document.querySelector("#load-more-tracks");
      observer.observe(target);
    }
  });


  const loadMoreTracks = (entries, observer) => {
    // console.log("loading more",allTracksLoaded, loadMore, isLoading)
    entries.map((entry) => {
      if (entry.isIntersecting && initialized) {
        if (allTracksLoaded) {
          setLoadMore(false);
        } else {
          setLoadMore(true);
        }
      }
    });
  };

  useEffect(() => {
    if(loadMore)
      getAllArtistTracks();
  },[loadMore])
  return (
    <>
      <div 
        className="w-full"
        style={{ background: "rgb(var(--bg))", color: "rgb(var(--text))", minHeight: "80vh", maxHeight : "80vh", overflowY:"scroll" }}>
             
        {artistData &&
          <div className=" mt-4 flex w-full">
            <div className=" sm:w-10/12 lg:block">
              <span
                className="album-header "
              >
                Results
              </span>
             <div className="flex mt-3 pb-4 lic-text">
                <div
                  className="flex px-1 py-1 max-h-7 notify-text rounded-2xl px-2" 
                  style={{ background: "rgb(255, 215, 232)", color: "rgb(var(--pink))" }}
                >
                  Artist : {artistData}
                </div>
            </div>
            </div>
          </div>
        }

        {isLoading && !initialized && (
          <div className='w-full'>
            <BouncingLoader />
          </div>
        )}

        {(!isLoading && artistTracks?.length == 0) && (
          <div className="text-xl text-center text-red-500">
            No Data Found
          </div>
        )}
        <>
        {artistTracks?.length > 0 &&
          artistTracks?.map((track, index, arr) => {
            return (
              <Track
                // tags={track.tags}
                image={Helper.getArtworkURL(track.AlbumID)}
                key={track.ID}
                albumId={track.AlbumID}
                title={track.DisplayTitle || track.Name}
                duration={track.LengthSeconds}
                bpm={track.Bpm}
                versions={track.AlternateCount}
                producer={track.Publisher}
                artistName={
                  track.Composer
                }
                album={track.AlbumName}
                trackId={track.ID}
                waveform={Helper.getWaveformURL(track.ID)}
                // setTrackUrl={props.setTrackUrl}
                // setFetchingTrack={trackContext.setFetchingTrack}
                // changeCurrentTrackImage={props.changeCurrentTrackImage}
                displayProjectModal={displayProjectModal}
                // handleCurrentTrackDetail={props.handleCurrentTrackDetail}
                // similarity={track?.similarity}
                description={track?.Comment}
                expandedTrackId={expandedTrackId}
                setExpandedTrackId={setExpandedTrackId}
                pageId={pageId}
                artists={
                  Helper.getComposers(track.Composers)
                }

                downloadingTracks = {downloadingTracks}
                setDownloadingTracks = {setDownloadingTracks}
                favingTracks = {favingTracks}
                setFavingTracks = {setFavingTracks}
                // commandOnChange = {setFilterTrackIds}

                highlights = {[]}
                lyrics = {track.Lyrics || ""}
                
              />
            );
          })
        }
        </>
        {!allTracksLoaded && (
          <div id="load-more-tracks" ref={ref} className="p-2">
           { loadMore ? <BouncingLoader /> : ""}
          </div>
        )}

        {/* {showProjectModal && (
          <AddTrackToProjectPopup
            trackToBeAddedToProject={trackToBeAddedToProject}
            closeProjectModal={closeProjectModal}
          />
        )} */}

        
      </div>
    </>
  );
};

export default ArtistTrackView;